import request from "root/js/request";

export const getAnalyticsCrossMPProductCostsV3 = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/product_cost_v3/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};

export const updateAnalyticsCrossMPProductCostsV3 = async ({
  cabinet_id,
  marketplace,
  data,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/product_cost_v3/bulk_update/",
    method: "post",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
    data: data,
  });
  return response.data;
};
